import { render, staticRenderFns } from "./ParaclinicalExaminationStep.vue?vue&type=template&id=72aef503"
import script from "./ParaclinicalExaminationStep.vue?vue&type=script&lang=js"
export * from "./ParaclinicalExaminationStep.vue?vue&type=script&lang=js"
import style0 from "./ParaclinicalExaminationStep.vue?vue&type=style&index=0&id=72aef503&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports